<template>
  <div>
    <nav class="global-nav">
      <ul class="global-nav__list">
        <li class="global-nav__item">
          <router-link to="/">
            <img
              src="@/assets/img/アセット 59@3x.png"
              v-if="isShowHome === true"
              @click="pushHome"
            />
          </router-link>
          <router-link to="/history">
            <img
              src="@/assets/img/アセット 61@3x.png"
              v-if="isShowHistory === true"
              @click="pushHistory"
            />
          </router-link>
          <img
            src="@/assets/img/アセット 60@3x.png"
            v-if="isShowLogout === true"
            @click="logout"
          />
        </li>
      </ul>
    </nav>
    <div class="hamburger" id="js-hamburger">
      <img
        v-if="isMenuactive === false"
        class="home-icon"
        src="@/assets/img/アセット 47@3x.png"
        @click="openmenu"
      />
      <img
        v-else
        class="close-icon"
        src="@/assets/img/アセット 57@3x.png"
        @click="closemenu"
      />
    </div>
    <div class="black-bg" id="js-black-bg"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuactive: false,
      isShowHome: false,
      isShowHistory: false,
      isShowLogout: false,
    };
  },
  methods: {
    openmenu() {
      if (this.$route.path === "/home") {
        this.isShowHistory = true;
        this.isShowLogout = true;
      } else if (this.$route.path === "/gameplay") {
        this.isShowHome = true;
      } else {
        this.isShowHome = true;
        this.isShowLogout = true;
      }
      this.isMenuactive = true;
      const body = document.body;
      body.classList.toggle("nav-open");
    },
    closemenu() {
      const body = document.body;
      body.classList.remove("nav-open");
      this.isMenuactive = false;
    },
    pushHome() {
      const body = document.body;
      body.classList.remove("nav-open");
      this.isMenuactive = false;
      if (this.$route.path === "/gameplay") {
        this.updatePlaysApi()
      }
    },
    pushHistory() {
      const body = document.body;
      body.classList.remove("nav-open");
      this.isMenuactive = false;
    },
    logout() {
      window.close();
    },
    async updatePlaysApi() {
      const playId = this.$store.state.playId
      const new_axios = this.axios.create({
        headers: {
          Authorization:
            "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
        responseType: "json",
      });
      const body = {
        "result_flg": 0,
        "retired_flg": 1,
        "number_to_completion": ''
      };
      const endpoint = process.env.API_ENDPOINT + "/plays/" + playId
      console.log(endpoint)
      const response = await new_axios
        .put(endpoint, body)
        .then(response => console.log(response))
        .catch(function (error) {
          console.log("エラーだよ", error);
        });
    }
  },
};
</script>

<style>
.home-icon {
  width: 100px;
}
.close-icon {
  width: 100px;
}

.global-nav {
  position: fixed;
  right: -350px;
  top: 0;
  width: 350px;
  height: 100vh;
  padding-top: 40px;
  background-image: url("~@/assets/img/アセット 58@3x.png");
  transition: all 0.6s;
  z-index: 101;
  overflow-y: auto;
}
.hamburger {
  position: absolute;
  right: 10px;
  top: -40px;
  width: 100px;
  height: 100px;
  cursor: pointer;
  z-index: 102;
}
.global-nav__list {
  margin-top: 150px;
  padding: 0;
  list-style: none;
}
.global-nav__item {
  text-align: center;
  padding: 0 14px;
}
.global-nav__item p {
  display: block;
  padding: 8px 0;
  text-decoration: none;
  color: #111;
  font-weight: bold;
  font-size: 20px;
}
.black-bg {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  background-color: #000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.6s;
  cursor: pointer;
}
/* 表示された時用のCSS */
.nav-open .global-nav {
  right: 0;
}

.global-nav__item img {
  width: 300px;
  margin: 10px;
}

.global-nav__item button:focus {
  outline: 0;
}
.nav-open .black-bg {
  opacity: 0.8;
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/Homeicon.vue